<template>
    <v-btn
        :icon="'fas fa-' + icon"
        size="small"
        variant="text"
        class="menu-item"
        :class="{ 'is-active': isActive ? isActive() : null }"
        :title="title"
        @click="action"
    >
    </v-btn>
</template>

<script setup lang="ts">
const { icon, title, action, isActive } = defineProps<{
    icon?: string
    title?: string
    action?: () => boolean | void
    isActive?: () => boolean
}>()
</script>

<style lang="scss" scoped>
.menu-item {
    max-width: 1.75rem !important;
    min-width: 1.75rem !important;
    max-height: 1.75rem !important;
    color: #333;
    background-color: transparent !important;
    padding: 0.25rem;
    margin-right: 0.25rem;

    &.is-active,
    &:hover {
        color: var(--v-accent-base);
        background-color: var(--v-primary-base);
    }
}
</style>
